import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { UserAsset } from '@models/dashboard.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';

import { AssetCardComponent } from '../asset/card/asset-card.component';

@Component({
  selector: 'ts-activity-6-my-line',
  templateUrl: './my-line.component.html',
  imports: [CommonModule, TranslationPipe, AssetCardComponent]
})
export class MyLineComponent {
  @Input() asset: UserAsset | undefined;
  @Input() class: string = '';
  @Input() card_wrap: boolean = true;
}
